Revolution.Module.extend({
    NAME: "mde.share", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/share.js)


    initialize: function ($) {
        //events
        if ($('.js-share-block')) {
            $('.js-launch-readspeaker').on('click', function() {
                $(this).closest('.bk-actions-toolbar').find('.open-readspeaker-ui').show().find('.rsplay').click();
            });
        }
    },

    onWindowLoad: function (e) {

    },

    onWindowScroll: function (e) {

    },

    onWindowResize: function (e) {

    },
});
